var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "img-fluid",
    id: "outputsvg",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      transform: "none",
      transformOrigin: "50% 50%",
      cursor: "move"
    },
    width: 512,
    height: 512,
    viewBox: "0 0 5120 5120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "l68z8MU0nPeJ8QUyIOzQph7",
    fill: "rgb(0,0,0)",
    style: {
      transform: "none"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pMayH5jTV",
    d: "M400 4350 c-30 -4 -73 -13 -94 -20 l-39 -12 769 -769 769 -769 245 244 c169 167 259 249 290 264 108 51 228 64 333 37 120 -31 140 -46 397 -302 l245 -243 769 769 769 769 -54 19 c-52 17 -146 18 -2199 19 -1180 1 -2170 -2 -2200 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIP4t0CMX",
    d: "M24 4028 c-18 -61 -19 -114 -19 -1473 0 -1355 1 -1412 19 -1467 10 -32 22 -58 25 -58 3 0 350 344 771 765 l765 765 -765 765 c-421 421 -768 765 -771 765 -3 0 -14 -28 -25 -62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppJuBDi3g",
    d: "M4300 3325 l-765 -765 765 -765 c421 -421 768 -765 771 -765 3 0 15 26 25 58 18 55 19 112 19 1472 0 1360 -1 1417 -19 1473 -10 31 -22 57 -25 57 -3 0 -350 -344 -771 -765z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzTmwDgqY",
    d: "M2495 3016 c-16 -8 -525 -509 -1129 -1114 l-1099 -1100 59 -19 c56 -17 156 -18 2234 -18 2078 0 2178 1 2234 18 l59 19 -1099 1100 c-643 643 -1112 1106 -1131 1114 -40 17 -89 17 -128 0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.d0c946e97563fc3ae4d9b0308a16360b.svg";
export { ForwardRef as ReactComponent };